<template>
    <v-dialog v-model="dialogDettaglioDocumento" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark :color="colorModalita" dense>
        <v-btn icon dark @click="closeDialogDocumento">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{dialogTitle}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="closeDialogDocumento">
            Chiudi
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <header-distinta :documento="locDistinta" :trigger="trigger" @aggiornaDocumento="aggiornaTestataDistinta" />
      <v-container fluid>
        <v-row dense>
          <v-col>
            <tabella-distinta :documento="locDistinta" :trigger="trigger" @aggiornaDistinta="aggiornaDistinta"/>
          </v-col>      
          <v-col>
            <grafico-distinta :documento="locDistinta" :trigger="trigger"/>
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row align="center" justify="end">
          <v-btn color="primary" class="mt-3 mr-5" :disabled="saveDisabled" @click="salvaDocumento">Salva distinta</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>      
</template>

<script>
  import { getAnnoRiferimento } from '@/components/helpers.js'
  import documenti from '@/services/documentiService.js'
  import configurazioni from '@/services/configurazioniService.js'
  import HeaderDistinta from './header.vue'
  import GraficoDistinta from './graficoDistinta'
  import TabellaDistinta from './tabellaDistinta'

  export default {
    components: {
      HeaderDistinta,
      GraficoDistinta,
      TabellaDistinta
    },
    props: {
      showDialog: { type: Boolean, default: false },
      idDocumento: { type: String, default: '' },
      nuovoDocumento: Boolean,
      // item: Object,
      readOnly: { type: Boolean, default: false }
    },
    data () {
      return {
        locDistinta: {model: '', generale: '', source: ''},
        dialogDettaglioDocumento: false,
        trigger: 1,
        triggerLocale: 1,
        daSalvare: false,
        mostraParcheggio: false,
        forzaDocumento: 'distintaBase'
      }
    },
    async mounted() {

    },
    watch:{
      async showDialog(value) {
        if (value) {
          await this.refresh()
        }
      },
      trigger() {
        this.daSalvare = true
      }         
    },
    computed: {
      dialogTitle() {
        // TODO: Specificare in base al tipo scelto
        return this.idDocumento ? `Distinta nr. ${this.idDocumento} ${this.readOnly ? ' (sola lettura)' : ''}` : 'Nuova Distinta base'
      },
      colorModalita() {
        if (this.coloreOrdine) {
          return this.nuovoDocumento ? 'amber' : 'amber darken-4'
        } else {
          return this.nuovoDocumento ? 'success' : 'primary'
        }
      },
      saveDisabled() {
        if (this.readOnly) return true
        return !this.daSalvare
      }     
    },
    methods: {
      async refresh() {
        console.log('refresh')
        if (this.idDocumento) {
          this.locDistinta = await documenti.getDocumento(this.idDocumento)
          this.completaAppoggio()
        } else {
          this.locDistinta = await documenti.getModello('xxx')
          this.completaAppoggio()
          this.locDistinta.data = new Date()
        }
        this.trigger++
        this.dialogDettaglioDocumento = true
      },
      completaAppoggio() {
        let itm = this.locDistinta
/*         _.set(itm,'appoggio.clienteVisibile', itm.tipoDocumento && itm.tipoDocumento.visualizzaCliente)
        _.set(itm,'appoggio.fornitoreVisibile', itm.tipoDocumento && itm.tipoDocumento.visualizzaFornitore)
        _.set(itm,'appoggio.spedizioneVisibile', itm.tipoDocumento && itm.tipoDocumento.infoSpedizione)
        _.set(itm,'appoggio.pagamentoVisibile', itm.tipoDocumento && itm.tipoDocumento.infoPagamento)
        _.set(itm,'appoggio.tipoDocumento', itm.tipoDocumento)
        const clifor = _.get(itm, 'anagrafica.cliente', '') || _.get(itm, 'anagrafica.fornitore', '')
        _.set(itm,'appoggio.clifor', clifor) */
      },
      async aggiornaTestataDistinta(testata) {
        console.log('testata', testata)
        this.completaAppoggio()
        this.trigger++
      },       
      async aggiornaDistinta(distinta) {
        Object.assign(this.locDistinta.distinta, distinta)
        this.completaAppoggio()
        this.trigger++
      },      
      closeDialogDocumento() {
        this.dialogDettaglioDocumento = false
        this.$emit('refresh')
      },
      async salvaDocumento() {
        let itm = this.locDistinta
        var result
        if (!itm._id) {
          if (!itm.tipoDocumento) {
            const tipi = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDocumento')
            const tipoDocumento = tipi.find(x => x.tipoDocumento === this.forzaDocumento)
            itm.tipoDocumento = tipoDocumento
          }          
          const numeratore = itm.tipoDocumento.numeratore
          const annoRiferimento = getAnnoRiferimento(itm.data)
          const numero = await configurazioni.getNumeratore(numeratore, true, annoRiferimento)
          itm._id = numero
          itm.codice = numero
          itm.magazzino = itm.magazzino || this.$store.getters['magazzini/codiceMagazzino']
          itm = JSON.parse(JSON.stringify(this.locDistinta))
          delete itm.appoggio

          result = await documenti.creaDocumento(itm)
        } else {
          itm = JSON.parse(JSON.stringify(this.locDistinta))
          delete itm.appoggio
          result = await documenti.aggiornaDocumento(itm)
        }
        this.locDistinta = result
        this.completaAppoggio()
        this.trigger++
        await this.$nextTick()
        this.daSalvare = false
        return result
      }
    }
  }
</script>
